import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/shared';
import { TransactionStateEnum } from './transaction-state.enum';
import { TransactionSummaryItemDto } from './transaction-summary-item.dto';
import { TransactionSummarySearchDto } from './transaction-summary-search.dto';

@Injectable({
  providedIn: 'root',
})
export class TransactionSummaryService {
  constructor(private _apiService: ApiService) {}
  searchTransactionSummary(searchParams: TransactionSummarySearchDto): Promise<Array<TransactionSummaryItemDto>> {
    return this._apiService.post('Transactions/Summary', searchParams, true).then((data: Array<TransactionSummaryItemDto>) => {
      data.forEach((x) => {
        if (x.VoidedCount > 0) {
          x.CurrentState = TransactionStateEnum.Voided;
        } else if (x.RefundCount > 0) {
          x.CurrentState = TransactionStateEnum.Refunded;
        } else if (x.Processed) {
          x.CurrentState = TransactionStateEnum.Processed;
        } else {
          x.CurrentState = TransactionStateEnum.Undefined;
        }
      });
      return Promise.resolve(data);
    });
  }

  export(searchParams: TransactionSummarySearchDto): Promise<string> {
    return this._apiService.post('Transactions/Summary/Export', searchParams, true);
  }
}
